document.addEventListener('DOMContentLoaded', function () {
  function handleOpen() {
    const slideoutId = this.getAttribute('data-slideout-trigger');
    const drawerContainer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer-container`);
    const drawer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer`);

    if (drawerContainer && drawer) {
      console.log('Opening drawer:', slideoutId);
      drawer.classList.toggle('open');
      drawerContainer.classList.toggle('open');
      drawerContainer.style.zIndex = '2147483650';
      document.body.classList.toggle('overflow-hidden');
    }
  }

  function handleClose() {
    console.log('Close trigger clicked');
    const openDrawers = document.querySelectorAll('.custom-slideout-drawer.open');
    const openContainers = document.querySelectorAll('.custom-slideout-drawer-container.open');

    openDrawers.forEach(drawer => drawer.classList.remove('open'));
    openContainers.forEach(container => {
      container.classList.remove('open');
      container.style.zIndex = ''; // reset z-index
    });

    document.body.classList.remove('overflow-hidden');
  }

  function CustomSlideoutDrawer() {
    // Attach open listeners (with guard)
    const triggers = document.querySelectorAll('[data-slideout-trigger]:not(.js-initialized)');
    triggers.forEach(trigger => {
      trigger.classList.add('js-initialized');
      trigger.addEventListener('click', handleOpen);
    });

    // Attach close listeners (with guard)
    const closeTriggers = document.querySelectorAll('[data-custom-slideout-drawer-close]:not(.js-initialized)');
    closeTriggers.forEach(trigger => {
      trigger.classList.add('js-initialized');
      trigger.addEventListener('click', handleClose);
    });
  }

  // Initial run
  CustomSlideoutDrawer();

  // Re-init automatically when new DOM elements are injected (hot reload, section changes, etc.)
  const domObserver = new MutationObserver(() => {
    CustomSlideoutDrawer();
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

  // Shopify Section events (optional safety for Online Store 2.0)
  document.addEventListener('shopify:section:load', CustomSlideoutDrawer);
  document.addEventListener('shopify:section:select', CustomSlideoutDrawer);
  document.addEventListener('shopify:section:deselect', CustomSlideoutDrawer);
  document.addEventListener('shopify:section:reorder', CustomSlideoutDrawer);
});